import React, { useState } from 'react'

import { Avatar, Popover } from 'antd'
import Form from 'pages/configuration/user/Components/Form'
import PropTypes from 'prop-types'

import DesktopProfileContent from './DesktopProfileContent'
import { Container } from './styles'

function DesktopView({
  setVisible,
  visible,
  userProfile,
  handleSubmit,
  items,
}) {
  const [popoverVisible, setPopoverVisible] = useState(false)

  return (
    <Container>
      <Popover
        placement="rightBottom"
        trigger="click"
        overlayStyle={{ width: 300 }}
        content={
          <DesktopProfileContent
            setVisible={setVisible}
            setPopoverVisible={setPopoverVisible}
          />
        }
        visible={popoverVisible}
        onVisibleChange={visibleChange => setPopoverVisible(visibleChange)}
      >
        <Avatar
          size="default"
          src={userProfile?.usu_foto || '/styles/img/avatars/avatar.png'}
          style={{
            cursor: 'pointer',
            marginLeft: 14,
            marginRight: 16,
          }}
        />
      </Popover>

      {visible && (
        <Form
          isProfile
          toggleModal={setVisible}
          handleSubmit={handleSubmit}
          values={userProfile}
          usersList={items}
          visible
          page
        />
      )}
    </Container>
  )
}

DesktopView.propTypes = {
  setVisible: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  userProfile: PropTypes.shape({
    usu_login: PropTypes.string,
    usu_foto: PropTypes.string,
    id_usuario: PropTypes.number,
    usu_nome: PropTypes.string,
    usu_email: PropTypes.string,
  }).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id_usuario: PropTypes.number,
      usu_nome: PropTypes.string,
    })
  ).isRequired,
}

export default DesktopView
